export enum BlogNavigationReference {
  CreatePost = 'blog-bwp-create-post',
  ViewPost = 'blog-bwp-view-post',
}
